<template>
  <div :style="'overflow-x: hidden;background: '+bgColor ">	
      <div>
      		<div class="banner-c"><img :src="imageConfig.indexFirst"></div>
      </div>
	  <div class="crumbs-all">
		  <div class="crumbs-c" style="display: flex;"><div @click="$router.push('/'+lang)" style="cursor: pointer;">首页</div> > 新闻中心</div>
	  </div>
	  <div class="news-c content-bd" >
		<div class="f-l"  :style="'background:'+font.newsCategoryBdColor+';font-weight:600;color:#000'">
			<ul>
				<li :class="{on:selectedType==0}" @click="goBackList(0)" :style="'font-size:'+font.newsTitleSize">公司新闻<span></span></li>
				<li :class="{on:selectedType==1}" @click="goBackList(1)" :style="'font-size:'+font.newsTitleSize">行业新闻<span></span></li>
			</ul>
		</div>
		<div class="f-r" :style="'min-height: 600px;background:'+font.newsRightBdColor">
			<div class="detail" style="padding: 10px 0;">
				<div style="font-size: 18px;font-weight: 600;padding: 0 0 20px 0;">{{newsDetail.newsTitle}}</div>
				<div class="l-content" style="margin-bottom: 20px;"><div style="float: left;color: #0070b7;">发布时间：</div>{{getTime(newsDetail.create_time)}}</div>
				<div v-html="newsDetail.newsContent" style="line-height: 30px;"></div>
			</div>	
		</div>
		<div class="clearfix"></div>
	  </div>
	  <p-bottom :lang="lang"></p-bottom>
  </div>
</template>

<script>
	
export default {
  name: 'News',
  props:{
  		lang:{},
  },
  data() {
    return {
      isCompanyNews:true,
	  newsDetail:'',
	  currentSelected:'',
	  selectedType:null,
	  imageConfig:{},
	  font:{},
	  bgColor:'#fff'
    }
  },
  methods: {
	handelBg(){
		if(localStorage.getItem('backgroudColor')){
			this.bgColor = JSON.parse(localStorage.getItem('backgroudColor')).newsBdColor
		}																					
	},
      async fetch(){
      	  const res=await this.$http.post(`/news`,{id:this.currentSelected,la:this.lang});
      	  this.newsDetail=res.data;
		  this.selectedType=this.newsDetail.type
		  
      },
	  async getImage(){
		const res=await this.$http.get('imageConfig')
		this.imageConfig = res.data[0]||{}
	  },
	  getTime(time){
	  	  const d=time;
		  if(time){
			  const list=d.split(/[T.]/)
			  return list[0]+" "+list[1];
		  }	  	  
	  },
	  goBackList(type){		  
		  this.selectedType=type;
		  localStorage.setItem('newsListTypeData', JSON.stringify({type:this.selectedType}))
		  this.$router.push("/news/"+this.lang)
	  },
	  async getFontConfig(){
			const res = await  this.$http.post('fontConfig')
			const fontContent = res.data
			if(fontContent.length!==0){
				this.font = fontContent[0]
				
			}
	  }
  },
  created(){
	  this.currentSelected=JSON.parse(localStorage.getItem('newsDetailData')).id;
	  this.getImage()
	  this.getFontConfig()
	  this.fetch()
	  this.handelBg()
  },
  watch: {
  			// 如果路由有变化，会再次执行该方法
  			"$route": "goBackList"
  }
  
}
</script>
<style >
	.news-c{
		background: #fff;	
	}
	.news-c .f-l{
		width: 300px;
		height: 430px;
		background: #fafafa;
		margin-left: 56px;
		padding-top: 34px;
	}
	.banner-c{
		position: relative;
		width: 100%;
		height: 460px;
		overflow: hidden;
	}
	.banner-c img{
		position: absolute;
		left:0;
		width:1920px;
		margin:0 calc(50% - 960px);
	}
	.news-c .f-l ul li{
		font-size: 18px;
		height: 65px;
		line-height: 65px;
		color: #666;
		padding: 0 58px;
		cursor: pointer;
		font-weight: 600;
	}
	.news-c .f-l ul li.on{
		background: #fff;
	}
	.news-c .f-l ul li:hover{
		background: #fff;
	}
	.news-c .f-l ul li span{
		background: url('../assets/images/news_arrow.jpg');
		display: block;
		width: 21px;
		height: 21px;
		float: right;
		margin-top: 22px;
	}
	.news-c .f-r{
		width: 736px;
		margin: 29px 40px;
    	float: left;
	}
	.news-c .f-r .l-title{
		font-size: 16px;
		color: #333;
		height: 28px;
		overflow: hidden;
	}
	.news-c .f-r .l-content{
		font-size: 13px;
		color: #999;
		height: 20px;
		overflow: hidden;
	}
	.detail img{
		width: 100%;
	}
</style>